import { NoteManager } from '../../../../managers/note.manager';
import { AfterViewInit, Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NoteTemplateItem, Note } from '../../../../models/domain/note';
import { ssApiService } from '@services/ss-api.service';
import { ProofreadNoteRequest } from '@models/ss-api/requests/proofread.note.request';

@Component({
    selector: 'note-details',
    templateUrl: './note.details.basic.component.html',
    styleUrls: ['./note.details.basic.component.css']
})
export class NoteDetailsBasicComponent implements AfterViewInit {

    IsBusy: boolean = false;
    reviewDisabled: boolean = true;
    NoteCharRemaining: number = 5000;

    private parentModal: HTMLElement | null = null;

    @Input('NoteManager') NoteManager: NoteManager;
    @ViewChild('NoteField') noteField: ElementRef;

    noteTemplates: NoteTemplateItem[] = [];
    selectedNoteTemplate: NoteTemplateItem;
    proofreadVersion: string;

    constructor(private api: ssApiService) { }

    ngAfterViewInit() {
        this.parentModal = document.querySelector('.modal');
        this.reviewDisabled = this.NoteManager.reviewDisabled;
        if (this.NoteManager.showTemplates)
            this.SetupTemplates();

        this.CalculateRemainingNoteCharacters();
    }

    resizeModal(){
        if (this.parentModal){
            this.parentModal.style.width = '1240px';
            this.parentModal.style.height = '900px';            
        }

    }

    Proofread(){
        this.IsBusy = true;

        var request = new ProofreadNoteRequest();
        request.MemberID = this.NoteManager.Note().MemberID;
        request.NoteText = this.NoteManager.Note().Note;

        let disposable = this.api.AIProofreadNote(request).subscribe(result => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.proofreadVersion = result.Data.CorrectedNote;

            this.resizeModal();        
        });        

    }

    Overwrite(){
        this.NoteManager.Note().Note = this.proofreadVersion;
    }

    onNoteKeyPress(): void {
        this.CalculateRemainingNoteCharacters();
    }

    CalculateRemainingNoteCharacters() {
        this.NoteCharRemaining = (5000 - this.NoteManager.Note().Note.length);
    }

    RemainingNoteCharactersString(): string {
        return (this.NoteCharRemaining == 1) ? 'Character' : 'Characters';
    }

    appendLink(event: Event) {
        event.preventDefault(); // prevent the link from navigating
        const snippet = '<a href="https://ssdb.structurestudios.com/member-profile/#####" target="_blank">HERE</a>';

        // Append the snippet to the existing note text
        const note = this.NoteManager.Note();
        note.Note = (note.Note || '') + snippet;
        this.CalculateRemainingNoteCharacters();
    }

    SetupTemplates() {

        this.noteTemplates = Note.NoteTemplates;

        let blankNote: NoteTemplateItem = { Title: 'No Template', Body: '' };

        this.noteTemplates.unshift(blankNote);

        this.selectedNoteTemplate = this.noteTemplates[0];

        this.TemplateChanged();

        console.log(Note);
    }

    TemplateChanged() {
        if (this.selectedNoteTemplate.Title == 'No Template') {
            this.NoteManager.Note().Note = '';
        } else {
            this.NoteManager.Note().Note = this.selectedNoteTemplate.Title + '\n' + this.selectedNoteTemplate.Body;
        }
        setTimeout(() => {
            this.noteField.nativeElement.focus();
        }, 50)
    }

}
